import { render } from "./AddMultipleSeatModalComponent.vue?vue&type=template&id=82c26136&scoped=true"
import script from "./AddMultipleSeatModalComponent.vue?vue&type=script&lang=js"
export * from "./AddMultipleSeatModalComponent.vue?vue&type=script&lang=js"

import "./AddMultipleSeatModalComponent.vue?vue&type=style&index=0&id=82c26136&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82c26136"]])

export default __exports__